import { render, staticRenderFns } from "./WhatsappIconSvg.vue?vue&type=template&id=0731ff62&"
import script from "./WhatsappIconSvg.vue?vue&type=script&lang=js&"
export * from "./WhatsappIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports